import { axiosClient } from '../utils/axiosClient.js';
import * as Paths from '@/components/common/paths';
import { handleServerError } from '@/components/common/errorUtils';
import i18n from '@/i18n';

// 翻訳キーから値を取得するヘルパー関数
const t = (key) => {
    try {
        return i18n.global.t(key);
    } catch (e) {
        return '';
    }
};

const actions = {
    async regist({ dispatch }, registData) {
        try {
            const response = await axiosClient.post(`${Paths.SUBJECT_URL}${registData.operator_id}`, registData);
            const data = response.data;

            if (data.type === 0) {
                dispatch('dataManagement/setInspectionId', data.inspection_id, { root: true });
                dispatch('dataManagement/setSubjectInfo', registData, { root: true });
                return { success: true };
            } else {
                console.error('Unexpected data type:', data.type);
                return { success: false, error: 'Unexpected data type' };
            }
        } catch (error) {
            console.error(handleServerError(error));
            return { success: false, error: t('errors.subject_registration_failed') };
        }
    },
};

export default {
    namespaced: true,
    actions,
};
